export default __webpack_public_path__ + "static/media/loader.3c8fd546.svg";